<template>
  <div
    class="fixed z-30 bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
  <!-- issue with items-center -->
    <div
      x-transition:enter="ease-out duration-300"
      x-transition:enter-start="opacity-0"
      x-transition:enter-end="opacity-100"
      x-transition:leave="ease-in duration-200"
      x-transition:leave-start="opacity-100"
      x-transition:leave-end="opacity-0"
      class="fixed inset-0 transition-opacity"
    >
      <div
        class="absolute inset-0 bg-gray-500 opacity-75"
        @click.self="$emit('close')"
      ></div>
    </div>

    <div
      x-transition:enter="ease-out duration-300"
      x-transition:enter-start="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      x-transition:enter-end="opacity-100 translate-y-0 sm:scale-100"
      x-transition:leave="ease-in duration-200"
      x-transition:leave-start="opacity-100 translate-y-0 sm:scale-100"
      x-transition:leave-end="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:max-h-screen"
    >
      <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <slot />
      </div>
      <div
        class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-center"
        v-if="this.$slots['buttons'] || this.$slots['buttons-start']"
      >
        <div class="flex-1 sm:flex sm:flex-row-reverse">
          <slot name="buttons" />
        </div>
        <div class="sm:flex">
          <slot name="buttons-start" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SqrModal',
};
</script>
